import React from "react";
import ReactModal from "react-modal";
import { ModalStyle, OverlayStyle } from "./Modal.styles";
import { useLockBodyScroll } from "../../../hooks/useLockBodyScroll";

const Modal = ({
  isOpen,
  children,
  onClose,
  shouldCloseOnOverlayClick = true,
  onAfterClose,
  animationDuration = 300,
  customOverlayStyles,
  customModalStyles,
  collectionModal,
}) => {
  useLockBodyScroll(isOpen);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      onAfterClose={onAfterClose}
      className="_"
      overlayClassName="_"
      contentElement={(props) => (
        <ModalStyle
          {...props}
          style={customModalStyles}
          $animationDuration={animationDuration}
        >
          {children}
        </ModalStyle>
      )}
      overlayElement={(props, contentElement) => (
        <OverlayStyle
          {...props}
          $customStyles={customOverlayStyles}
          $collectionModal={collectionModal}
        >
          {contentElement}
        </OverlayStyle>
      )}
      shouldCloseOnEsc={shouldCloseOnOverlayClick}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    />
  );
};

export default Modal;
